import { render, staticRenderFns } from "./BossBoard.vue?vue&type=template&id=9c51f650&scoped=true&lang=pug&"
import script from "./BossBoard.vue?vue&type=script&lang=ts&"
export * from "./BossBoard.vue?vue&type=script&lang=ts&"
import style0 from "./BossBoard.vue?vue&type=style&index=0&id=9c51f650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c51f650",
  null
  
)

export default component.exports